export * from 'remeda';

export function arrayMax(array: number[]): number {
  if (array.length === 0) {
    return 0;
  }
  return Math.max(...array);
}
